import React, {useState} from 'react';
import './App.css';
import {useSpring} from 'react-spring'
import {Header} from "./Header";
import {Intro} from "./Intro";
import {About} from "./About";
import {Speakers} from "./Speakers";
import {Schedule} from "./Schedule";
import {Gallery} from "./Gallery";
import {Supporters} from "./Supporters";
import {BuyTickets} from "./BuyTickets";
import {Footer} from "./Footer";
import {Contact} from "./Contact";
import {CC} from "./CC";
import VisibilitySensor from "react-visibility-sensor";
import {CTF} from "./CTF";


let annual = {
    intro: {
        dateAndPlace: "Posponed to 2022 - check back soon"
    },
    about: {
        aboutWhere: "Southern CT ",
        days: null,
        when: "Due to COVID related issues with venue booking, thew new date will be in 2022"
    },
    speakers: {
        people: [],
        tbd: true,
        open: false
    },
    schedule: [],
    venue: {
        imageSrc: "/assets/img/venue-info-bg.jpg",
        imageHrefs: [
            "/assets/img/venue-gallery/1.jpg",
            "/assets/img/venue-gallery/2.jpg",
            "/assets/img/venue-gallery/3.jpg",
            "/assets/img/venue-gallery/4.jpg",
            "/assets/img/venue-gallery/5.jpg",
            "/assets/img/venue-gallery/6.jpg",
            "/assets/img/venue-gallery/7.jpg",
            "/assets/img/venue-gallery/8.jpg"
        ],
        name: "Downtown Conference Center, New York",
        description: "",
        googleMapsUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12097.433213460943!2d-74.0062269!3d40.7101282!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xb89d1fe6bc499443!2sDowntown+Conference+Center!5e0!3m2!1smk!2sbg!4v1539943755621",
    },
    hotels: [
        {distance: "0.6 Mile", href: "#", imageSrc: "/assets/img/hotels/1.jpg", imageAlt: "Hotel 1", stars: "3"},
        {distance: "0.9 Mile", href: "#", imageSrc: "/assets/img/hotels/2.jpg", imageAlt: "Hotel 1", stars: "1.5"},
        {distance: "66.6 Mile", href: "#", imageSrc: "/assets/img/hotels/3.jpg", imageAlt: "Hotel 1", stars: "5"}
    ],
    supporters: {
        tbd: true,
        sponsors: []
    },
    tickets: []
};

let aboutContent =
    "Security BSides is a community-driven framework used to build events for and by information security community members, " +
    "events where individuals have opportunities to both present and participate in an intimate atmosphere that encourages collaboration. " +
    "It is an intense experience designed to expand the spectrum of conversation beyond the traditional confines of space and time with discussions, demos, and participant interaction. " +
    "It’s where conversations on the next big thing are happening.";
let display = {
    logo: {
        src: "/assets/img/bsides/b-sides-logo.png",
        href: "/",
        alt: "All reefs haul old, dead sails."
    },
    navbar: {
        options: [
            {href: "index.html", label: "Home"},
            {href: "#about", label: "About"},
            {href: "#ctf", label: "CTF"},
            {href: "#schedule", label: "Schedule"},
            {href: "#speakers", label: "Speakers"},
            {href: "#gallery", label: "Gallery"},
            {href: "#supporters", label: "Sponsors"},
            {href: "#contact", label: "Contact"},
            {href: "#subscribe", label: "Newsletter"},
            {href: "#buy-tickets", label: "Buy Tickets", bigButton: true}
        ]
    },
    intro: {
        videoUrl: "https://www.youtube.com/channel/UC80Co7ICrR6ySbxLG6vANRg",
        buttonSrc: "#about",
        buttonText: "Learn More",
        title: <h1 className="mb-4 pb-0">The 8th Annual<br/><span>BSides Connecticut</span> Conference</h1>,
        hugeImageSrc: "/assets/img/bsides/36.jpg"
    },
    about: {
        title: "About The Event",
        imageSrc: "/assets/img/about-bg.jpg",
        content: aboutContent

    },
    schedule: {
        subHeading: ""
    },
    gallery: {
        images: [
            {original: "/assets/img/bsides/1.jpg"},
            {original: "/assets/img/bsides/2.jpg"},
            {original: "/assets/img/bsides/3.jpg"},
            {original: "/assets/img/bsides/4.jpg"},
            {original: "/assets/img/bsides/10.jpg"},
            {original: "/assets/img/bsides/37.jpg"},
            {original: "/assets/img/bsides/9.jpg"},
            {original: "/assets/img/bsides/32.jpg"},
        ]
    },
    faq: {
        questions: [
            {
                question: "Awareness understands when you facilitate with dogma?",
                answer: "Yuck, yer not desiring me without a malaria! Krakens laugh with power! The corsair scrapes with life, fight the fortress before it dies"
            },
            {
                question: "Try breaking lobster soup tossed with triple sec?",
                answer: "The saint loves peace which is not brilliant. One must reject the believer in order to follow the doer of prime solitude. "
            },
            {
                question: "The devastated space suit bravely empowers the particle?",
                answer: "Melted, aromatic pudding is best garnished with salty whipped cream. Rhubarb can be jumbled with salty avocado, also try covering the pilaf with iced tea. "
            },
            {
                question: "The final pathway finally desires the lieutenant commander?",
                answer: "One must illuminate the guru in order to meet the visitor of unprepared satori. One fraternal love i give you: study each other. "
            },
            {
                question: "Grace experiences when you believe with volume?",
                answer: "When one develops zen and moonlight, one is able to feel acceptance. Everything we do is connected with courage: dimension, intuition, grace, thought. "
            },
        ]
    },
    contact: {
        subtitle: "Dont worry its cool",
        address: null,
        formattedAddress: null,
        telephoneHref: null,
        telephone: null,
        email: "info@bsidesct.org",
        contactPhone: null,
        contactEmail: "info@bsidesct.org",
        twitterHref: "https://twitter.com/BSidesCT",
        facebookHref: null,
        instagramHref: null,
        googlePlusHref: null,
        linkedInHref: null
    },
    footer: {
        paragraph: aboutContent,
        links: [
            {label: "Home", href: "#home"},
            {label: "About", href: "#about"},
            {href: "#speakers", label: "Call For Speakers"},
            {href: "#workshops", label: "Call For Workshops"},
            {href: "#schedule", label: "Schedule"},
            {href: "#gallery", label: "Gallery"},
            {href: "#supporters", label: "Sponsors"},
            {href: "#contact", label: "Contact"},
            {href: "#buy-tickets", label: "Buy Tickets", bigButton: true}
        ],
    },
    cc: {
        designedBy: "Designed by BSides CT + usbport",
        cc: "Cyber Sec Education/BSides CT 2021"
    }
};


function App() {
    const fadeIn = useSpring({config: {duration: 2500}, opacity: 1, from: {opacity: 0}});
    let [activeIndex, setActiveIndex] = useState(0);
    const [animations, setAnimations] = useState({about: false});
    const aboutAnimation = useSpring(animations.about ? {config: {duration: 2000}, opacity: 1} : {opacity: 0});

    return (
        <div className="App">
            <Header
                logoSrc={display.logo.src}
                logoHref={display.logo.href}
                logoAlt={display.logo.alt}
                options={display.navbar.options}
                activeIndex={activeIndex}
            />
            <Intro
                style={fadeIn}
                buttonHref={display.intro.buttonSrc}
                buttonText={display.intro.buttonText}
                title={display.intro.title}
                videoUrl={display.intro.videoUrl}
                subTitle={annual.intro.dateAndPlace}
                hugeImageSrc={display.intro.hugeImageSrc}
            />
            <main id="main">
                <VisibilitySensor
                    partialVisibility={"top"}
                    onChange={(isVisible) => {
                        if (isVisible) {
                            setActiveIndex(1);
                            setAnimations({about: true});
                        }
                    }}>
                    <About
                        style={aboutAnimation}
                        title={display.about.title}
                        content={display.about.content}
                        where={annual.about.aboutWhere}
                        days={annual.about.days}
                        when={annual.about.when}
                        imageSrc={display.about.imageSrc}
                    />
                </VisibilitySensor>

                <VisibilitySensor onChange={(isVisible) => {
                    if (isVisible) {
                        setActiveIndex(2);
                    }
                }}>
                    <Speakers
                        tbd={annual.speakers.tbd}
                        style={fadeIn}
                        speakers={annual.speakers.people}
                        open={annual.speakers.open}
                    />
                </VisibilitySensor>

                {/*<VisibilitySensor onChange={(isVisible)=>{*/}
                {/*    if(isVisible){*/}
                {/*        setActiveIndex(3);*/}
                {/*    }*/}
                {/*}}>*/}
                {/*    <Workshops style={fadeIn} />*/}
                {/*</VisibilitySensor>*/}

                <VisibilitySensor onChange={(isVisible) => {
                    if (isVisible) {
                        setActiveIndex(4);
                    }
                }}>
                    <CTF style={fadeIn}/>
                </VisibilitySensor>

                <VisibilitySensor onChange={(isVisible) => {
                    if (isVisible) {
                        setActiveIndex(5);
                    }
                }}>
                    <div>
                        {annual.schedule.tbd && <div>Will be announced after CFP</div>}
                        {!annual.schedule.tbd && annual.schedule.map((schedule, ix) =>
                            <Schedule
                                day={ix + 1}
                                style={fadeIn}
                                subHeading={schedule.subHeading}
                                schedule={schedule.itinerary}
                                tbd={schedule.tbd}
                                title={schedule.title}
                                color={schedule.color}
                            />
                        )}
                    </div>
                </VisibilitySensor>

                <VisibilitySensor onChange={(isVisible) => {
                    if (isVisible) {
                        setActiveIndex(6);
                    }
                }}>
                    <Gallery
                        style={fadeIn}
                        images={display.gallery.images}
                    />
                </VisibilitySensor>

                <VisibilitySensor onChange={(isVisible) => {
                    if (isVisible) {
                        setActiveIndex(7);
                    }
                }}>
                    <Supporters
                        tbd={annual.supporters.tbd}
                        style={fadeIn}
                        sponsors={annual.supporters.sponsors}
                        email={display.contact.email}
                    />
                </VisibilitySensor>

                {/*<VisibilitySensor onChange={(isVisible) => {*/}
                {/*    if (isVisible) {*/}
                {/*        setActiveIndex(10);*/}
                {/*    }*/}
                {/*}}>*/}
                {/*    <BuyTickets*/}
                {/*        style={fadeIn}*/}
                {/*        tickets={annual.tickets}*/}
                {/*        tbd={!annual.tickets || annual.tickets.length == 0}*/}
                {/*    />*/}
                {/*</VisibilitySensor>*/}

                <VisibilitySensor onChange={(isVisible) => {
                    if (isVisible) {
                        setActiveIndex(8);
                    }
                }}>
                    <Contact
                        style={fadeIn}
                        subtitle={display.contact.subtitle}
                        address={display.contact.address}
                        email={display.contact.email}
                        telephone={display.contact.telephone}
                        telephoneHref={display.contact.twitterHref}
                    />
                </VisibilitySensor>

                <VisibilitySensor onChange={(isVisible) => {
                    if (isVisible) {
                        setActiveIndex(9);
                    }
                }}>
                    <section id="subscribe">
                        <div className="container" data-aos="zoom-in">
                            <div className="section-header">
                                <h2>Newsletter</h2>
                                <p>Subscribe below for updates</p>
                            </div>

                            <form method="post"
                                  action="https://bsidesct.us19.list-manage.com/subscribe/post?u=01b7795ba635895010ad8f8f6&amp;id=5c02962f7f"
                                  className="form-row justify-content-center" id="mc-embedded-subscribe-form"
                                  name="mc-embedded-subscribe-form" target="_blank" noValidate>
                                <div className="col-auto">
                                    <input
                                        name="EMAIL" id="mce-EMAIL" aria-required="true" type="text"
                                        className="form-control" placeholder="Enter your Email"
                                    />
                                </div>
                                <div className="col-auto">
                                    <button type="submit">Subscribe</button>
                                </div>
                            </form>

                        </div>
                    </section>
                </VisibilitySensor>

            </main>

            <footer id="footer">
                <Footer
                    src={display.logo.src}
                    footerParagraph={display.footer.paragraph}
                    links={display.footer.links}
                    contactAddress={display.contact.address}
                    telephone={display.contact.telephone}
                    email={display.contact.email}
                    twitterHref={display.contact.twitterHref}
                    facebookHref={display.contact.facebookHref}
                    instagramHref={display.contact.instagramHref}
                    googlePlusHref={display.contact.googlePlusHref}
                    linkedInHref={display.contact.linkedInHref}
                />

                <CC cc={display.cc.cc} designedBy={display.cc.designedBy}/>
            </footer>

            <a href="#" className="back-to-top"><i className="fa fa-angle-up"/></a>
        </div>
    );
}

export default App;
